import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Compteur de mots et de caracteres";
const DESCRIPTION =
  "Compteur de mots et de caracteres. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "word counter, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/word-counter/";
function WordCounter() {
  const [sentence, setSentence] = useState("");
  const [wordCount, setWordCount] = useState(null);
  const [charCount, setCharCount] = useState(0);
  const [letterCount, setLetterCount] = useState(0);
  const [error, setError] = useState("");
  const calculateWordCount = () => {
    try {
      if (sentence.trim() === "") {
        setError("Veuillez entrer une phrase pour compter les mots");
        return;
      }
      setCharCount(sentence.length);
      setLetterCount(sentence.replace(/\s+/g, "").length);
      const words = sentence.trim().split(/\s+/).length;
      setWordCount(words);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cet outil fournit un moyen simple et rapide de compter le nombre de mots dans une phrase ou un texte donné. 
                  Connaître le nombre de mots peut être utile dans plusieurs contextes, comme déterminer le nombre de mots dans 
                  un article, respecter les exigences de rédaction ou même améliorer vos compétences en écriture. Vous pouvez 
                  utiliser cet outil pour vous aider à estimer la taille des textes et à planifier le contenu de la rédaction 
                  de manière plus précise.
                </p>
                <p>
                  Par exemple, si vous écrivez un article et que vous devez vous assurer qu'il contient un certain nombre de mots, 
                  vous pouvez saisir le texte dans cette calculatrice pour connaître le nombre total de mots. Cela peut vous aider 
                  à vérifier votre conformité avec les exigences de rédaction ou à analyser les textes pour déterminer leur densité. 
                  L'outil de comptage de mots peut être très utile pour vérifier que vos textes répondent aux critères et pour 
                  améliorer votre processus d'écriture global.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="sentence">Entrez votre texte :</label>
                    <textarea
                      id="sentence"
                      value={sentence}
                      onChange={(e) => setSentence(e.target.value)}
                      className="form-control"
                      style={{ width: "75%", height: "100px" }}
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateWordCount}
                  >
                    Calculer
                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Erreur : {error}</p>
                ) : (
                  wordCount !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>Nombre de mots : {wordCount}</p>
                      <p>Nombre de caractères avec espaces : {charCount}</p>
                      <p>Nombre de caractères sans espaces : {letterCount}</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Comment compter les mots</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Étape 1 : Entrer le texte</h2>
                  </u>
                  <p>
                    Tout d'abord, vous devez saisir la phrase ou le texte dont vous souhaitez compter le nombre de mots. 
                    Assurez-vous de saisir le texte complètement et avec précision pour obtenir un compte correct. Vous pouvez 
                    saisir le texte dans le champ de texte disponible dans la calculatrice. Cette étape est essentielle car 
                    le calcul dépend du texte que vous saisissez.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Étape 2 : Commencer le calcul</h2>
                  </u>
                  <p>
                    Après avoir saisi le texte, cliquez sur le bouton "Calculer" pour commencer le processus de calcul. 
                    La calculatrice analysera le texte et déterminera le nombre de mots qu'il contient en divisant le texte 
                    en mots en utilisant les séparateurs et les espaces. Assurez-vous qu'il n'y a pas de texte supplémentaire 
                    inutile pour assurer la précision du calcul.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Étape 3 : Affichage du résultat</h2>
                  </u>
                  <p>
                    Après avoir terminé le calcul, la calculatrice affichera le nombre de mots dans le texte que vous avez saisi. 
                    Vous pouvez utiliser ces informations pour vérifier votre conformité aux exigences spécifiées pour le nombre 
                    de mots ou pour analyser vos textes de manière plus précise. Connaître le nombre de mots peut vous aider à 
                    améliorer vos compétences en écriture et à déterminer la complétude du texte.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Exemple : Si vous saisissez le texte "Bonjour, comment allez-vous aujourd'hui?", la calculatrice affichera 
                    que le nombre de mots est de 5 mots.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 4 : Utiliser le nombre de mots
                    </h2>
                  </u>
                  <p>
                    Après avoir connu le nombre de mots, vous pouvez l'utiliser à plusieurs fins, notamment pour organiser 
                    le contenu, vérifier la conformité avec les exigences de rédaction ou améliorer vos textes. Cet outil peut 
                    être utile lors de la rédaction d'articles, de la préparation de rapports ou de tout autre type de textes 
                    qui nécessite un suivi précis du nombre de mots.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Exemple : Si vous écrivez un article et que vous devez déterminer le nombre de mots pour vous assurer 
                    qu'il répond aux exigences de publication, vous pouvez utiliser la calculatrice pour connaître le nombre final.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default WordCounter;
